// @ts-nocheck
import { fabric } from 'fabric';
import _ from 'lodash';
import {
  convertBeatTypeNumberToText,
  formatHesBeatStatus,
  isDeleteBeatMode,
} from '../../../ui/helper';
import { ANNOTATION_TYPE, DEFAULT_FONT } from '../../../config';

let BeatMarkers;

(function () {
  const BEAT_MAX_DISTANCE = 45;
  const NORMAL_BEAT_COLOR = {
    N: '#6D7B8F',
    S: '#FA5A5F',
    V: '#FA893C',
    Q: '#846EFA',
  };
  const UNHOVER_BEAT_COLOR = {
    N: '#9DA7B2',
    S: '#E08789',
    V: '#E09663',
    Q: '#A097CC',
  };
  const HOVER_BEAT_COLOR = {
    N: '#364152',
    S: '#E51C22',
    V: '#E05E04',
    Q: '#5637FA',
  };
  const NORMAL_TEXT_COLOR = '#1D2F47';
  const ARBEAT_TEXT_COLOR = '#4B5B73';
  const FONT = {
    fontFamily: DEFAULT_FONT,
    fontSize: 12,
    fontWeight: 100,
    selectable: false,
    hasControls: false,
    hasBorders: false,
    hasRotatingPoint: false,
    selection: false,
    skipTargetFind: false,
    editable: false,
  };

  BeatMarkers = function ({
    canvas,
    beatMarkers = [],
    verticalChannelPlacement,
    config,
    isAppliedAI,
    isShowVES,
    isShowSVES,
    hesBeatStatus = [],
    aiData,
    handleOpenSnackbar,
  }: any) {
    this.canvas = canvas;
    this.type = ANNOTATION_TYPE.BEAT_MARKER;
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.config = config;
    this.bpmArray = [];
    this.arrayBeatMarker = [];
    this.sizeBeatMarker = 0;
    this.arrayLabel = [];
    this.sizeLabel = 0;
    this.isVisibility = true;
    this.isAppliedAI = isAppliedAI;
    this.beatMarkers = [...beatMarkers];
    this.originalHesBeatStatus = [...hesBeatStatus];
    this.currentHesBeatStatus = [...hesBeatStatus];
    this.isShowVES = isShowVES;
    this.isShowSVES = isShowSVES;
    this.aiData = aiData;
    this.hoverBeat = null;
    this.selectedBeats = [];
    this.isSelectingBeat = false;
    this.handleOpenSnackbar = handleOpenSnackbar;
    this.normalColor = NORMAL_BEAT_COLOR;
    this.textColor = NORMAL_TEXT_COLOR;
  };

  BeatMarkers.prototype.updateARBeatMode = function (isEnter: any) {
    this.normalColor = isEnter ? UNHOVER_BEAT_COLOR : NORMAL_BEAT_COLOR;
    this.textColor = isEnter ? ARBEAT_TEXT_COLOR : NORMAL_TEXT_COLOR;
  };

  BeatMarkers.prototype.update = function ({
    beatMarkers = [],
    verticalChannelPlacement,
    config,
    isAppliedAI,
    isShowVES,
    isShowSVES,
    hesBeatStatus = [],
    aiData,
  }: any) {
    this.bpmArray.length = 0;
    this.beatMarkers = [...beatMarkers];
    this.originalHesBeatStatus = [...hesBeatStatus];
    this.currentHesBeatStatus = [...hesBeatStatus];
    this.isAppliedAI = isAppliedAI;
    this.isShowVES = isShowVES;
    this.isShowSVES = isShowSVES;
    this.aiData = aiData;
    if (!isShowVES) {
      this.changeHesBeatStatus(60);
    }
    if (!isShowSVES) {
      this.changeHesBeatStatus(70);
    }
    this.verticalChannelPlacement = verticalChannelPlacement;
    this.config = config;
  };

  BeatMarkers.prototype.render = function () {
    this.canvas.renderAll();
  };

  BeatMarkers.prototype.draw = function (offsetX: any, isInViewAllMode: any) {
    if (!isInViewAllMode && this.config.speed !== 2.5) {
      this.drawBeatMarkerLabels(offsetX);
      this.drawBeatMarker(offsetX);
    }
  };

  BeatMarkers.prototype.drawBeatMarker = function (offsetX: any) {
    const { numberOfVisibleChannels } = this.config;

    this.sizeBeatMarker = 0;
    for (let i = 0; i < this.beatMarkers.length; i += 1) {
      const type = convertBeatTypeNumberToText(this.currentHesBeatStatus[i]);

      const xPos = this.indexToPixOffset(this.beatMarkers[i], offsetX);
      const yPos = 5;

      // *: Beat marker should be drawn no more than BEAT_MAX_DISTANCE away from lower baseline
      const minYPos =
        this.verticalChannelPlacement[numberOfVisibleChannels - 1] + BEAT_MAX_DISTANCE;
      const yPosAdjusted = Math.min(yPos, minYPos);

      this.drawTriangle(xPos, yPosAdjusted, this.sizeBeatMarker, type, this.beatMarkers[i]);
    }

    for (let i = this.sizeBeatMarker; i < this.arrayBeatMarker.length; i += 1) {
      this.arrayBeatMarker[i].text.visible = false;
      this.arrayBeatMarker[i].triangle.visible = false;
      this.arrayBeatMarker[i].rectangle.visible = false;
    }
  };

  BeatMarkers.prototype.drawBeatMarkerLabels = function (offsetX: any) {
    const { numberOfVisibleChannels } = this.config;
    this.sizeLabel = 0;
    for (let i = 0; i < this.beatMarkers.length - 1; i += 1) {
      const measurementText = this.getBeatMarkerLabel(this.beatMarkers[i], this.beatMarkers[i + 1]);
      const x1Px = this.indexToPixOffset(this.beatMarkers[i], offsetX);
      const x2Px = this.indexToPixOffset(this.beatMarkers[i + 1], offsetX);
      const yPx = 2;

      // *: Beat marker should be drawn no more than BEAT_MAX_DISTANCE away from lower baseline
      const minYPx = this.verticalChannelPlacement[numberOfVisibleChannels - 1] + BEAT_MAX_DISTANCE;
      const yPxAdjusted = Math.min(yPx, minYPx);
      this.drawText(measurementText, x1Px, x2Px, yPxAdjusted, this.sizeLabel);
    }

    for (let i = this.sizeLabel; i < this.arrayLabel.length; i += 1) {
      this.arrayLabel[i].visible = false;
    }
  };

  BeatMarkers.prototype.getBeatMarkerLabel = function (
    sampleA: any,
    sampleB: any,
    hasLabel = true,
  ) {
    const { samplingRate } = this.config;
    const difference = Math.abs(sampleA - sampleB);
    const miliSec = (difference * 1000) / samplingRate;
    const bpm = 60 / (miliSec / 1000);
    this.bpmArray.push(Math.round(bpm));
    return hasLabel ? `${Math.round(miliSec)}\n${Math.round(bpm)}` : bpm;
  };

  BeatMarkers.prototype.getMinMaxHr = function () {
    return {
      minHr: _.min(this.bpmArray),
      maxHr: _.max(this.bpmArray),
    };
  };

  BeatMarkers.prototype.drawText = function (
    measurementText: any,
    x1Px: any,
    x2Px: any,
    yPxAdjusted: any,
    i: any,
  ) {
    const { width } = this.config;
    const left = (x1Px + x2Px) / 2;
    if (left > -measurementText.length * 7 && left < width) {
      this.sizeLabel += 1;
      if (i >= this.arrayLabel.length) {
        const text = new fabric.Text(measurementText, {
          ...FONT,
          fontSize: 12,
          left,
          top: yPxAdjusted,
          textAlign: 'justify-center',
          originX: 'center',
          lineHeight: 0.9,
          visible: this.isVisibility,
          fill: this.textColor,
        });
        text.type = 'text';
        this.arrayLabel.push(text);
        this.canvas.add(text);
      } else {
        this.arrayLabel[i].set({
          visible: this.isVisibility,
          left,
          top: yPxAdjusted,
          text: measurementText,
          fill: this.textColor,
        });
        this.arrayLabel[i].setCoords();
      }
    }
  };

  BeatMarkers.prototype.drawTriangle = async function (
    startX: any,
    startY: any,
    i: any,
    type: any,
    beatSample: any,
  ) {
    const { width } = this.config;

    if (startX > 0 && startX < width) {
      this.sizeBeatMarker += 1;
      if (i >= this.arrayBeatMarker.length) {
        const rectangle = new fabric.Rect({
          ...FONT,
          fontSize: 12,
          width: 9,
          height: 11,
          top: startY,
          left: startX - 4,
          hoverCursor: 'pointer',
          strokeWidth: 0,
          visible: this.isVisibility,
          fill: this.normalColor[type],
          borderColor: this.normalColor[type],
          rx: 1,
          ry: 1,
        });

        const triangle = new fabric.Triangle({
          ...FONT,
          fontSize: 12,
          width: 9,
          height: 4,
          top: startY + 11,
          left: startX - 4,
          hoverCursor: 'pointer',
          flipY: true,
          strokeWidth: 0,
          visible: this.isVisibility,
          fill: this.normalColor[type],
          borderColor: this.normalColor[type],
        });

        const text = new fabric.IText(type, {
          ...FONT,
          fontSize: 10,
          width: 5,
          top: startY + 1,
          hoverCursor: 'pointer',
          fill: 'white',
          visible: this.isVisibility,
        });
        text.left = startX - text.width / 2;
        this.arrayBeatMarker.push({
          rectangle,
          triangle,
          text,
          originType: type,
          beatSample,
        });
        this.canvas.add(rectangle, triangle, text);
      } else {
        if (type !== this.arrayBeatMarker[i].text.text && !this.isSelectingBeat) {
          this.arrayBeatMarker[i].text.set({ text: type });
        }

        this.arrayBeatMarker[i].rectangle.set({
          visible: this.isVisibility,
          top: startY,
          left: startX - 4,
          fill: this.normalColor[type],
          borderColor: this.normalColor[type],
        });

        this.arrayBeatMarker[i].triangle.set({
          visible: this.isVisibility,
          top: startY + 11,
          left: startX - 4,
          fill: this.normalColor[type],
          borderColor: this.normalColor[type],
        });

        this.arrayBeatMarker[i].text.set({
          visible: this.isVisibility,
          top: startY + 1,
          left: startX - this.arrayBeatMarker[i].text.width / 2,
        });

        this.arrayBeatMarker[i].originType = type;
        this.arrayBeatMarker[i].beatSample = beatSample;
      }
    }
  };

  BeatMarkers.prototype.deselectBeat = function () {
    this.isSelectingBeat = false;
    this.selectedBeats.forEach((beat: any) => {
      beat.triangle.set({
        fill: this.normalColor[beat.originType],
        borderColor: this.normalColor[beat.originType],
      });
      beat.rectangle.set({
        fill: this.normalColor[beat.originType],
        borderColor: this.normalColor[beat.originType],
      });
      beat.text.set({
        text: beat.originType,
      });
    });
    this.selectedBeats = [];
  };

  BeatMarkers.prototype.handleSelectBeat = function ({
    startSample,
    endSample,
    beatTypeNumber,
  }: any) {
    this.isSelectingBeat = true;
    this.selectedBeats.forEach((beat: any) => {
      beat.triangle.set({
        fill: this.normalColor[beat.originType],
        borderColor: this.normalColor[beat.originType],
      });
      beat.rectangle.set({
        fill: this.normalColor[beat.originType],
        borderColor: this.normalColor[beat.originType],
      });
      beat.text.set({
        text: beat.originType,
      });
    });
    const isDelete = isDeleteBeatMode(beatTypeNumber);
    /**
     * Selects the beat-marker sample positions within the given startSample to endSample range. Filters beatMarkers inclusively between the bounds.
     *
     * @returns Beat-marker sample positions in range.
     */
    const selectedBeatsSample = this.beatMarkers.filter(
      (beatSample: any) => beatSample >= startSample && beatSample <= endSample,
    );
    /**
     * Selects the beat-marker objects whose beatSample is included in the selected samples set. Filters arrayBeatMarker against selectedBeatsSample.
     *
     * @returns The selected beat-marker objects.
     */
    const selectedBeatMarker = this.arrayBeatMarker.filter((beat: any) =>
      selectedBeatsSample.includes(beat.beatSample),
    );
    const type = convertBeatTypeNumberToText(beatTypeNumber);
    selectedBeatMarker.forEach((beat: any) => {
      beat.triangle.set({
        fill: HOVER_BEAT_COLOR[isDelete ? beat.originType : type],
        borderColor: HOVER_BEAT_COLOR[isDelete ? beat.originType : type],
      });
      beat.rectangle.set({
        fill: HOVER_BEAT_COLOR[isDelete ? beat.originType : type],
        borderColor: HOVER_BEAT_COLOR[isDelete ? beat.originType : type],
      });
      if (!isDelete) {
        beat.text.set({
          text: type,
        });
      }
    });
    this.selectedBeats = selectedBeatMarker;
    this.render();
  };

  BeatMarkers.prototype.resetHoverBeat = function () {
    if (this.beatHover) {
      this.beatHover.rectangle.set({
        fill: this.normalColor[this.beatHover.originType],
        borderColor: this.normalColor[this.beatHover.originType],
      });
      this.beatHover.triangle.set({
        fill: this.normalColor[this.beatHover.originType],
        borderColor: this.normalColor[this.beatHover.originType],
      });
    }
  };

  BeatMarkers.prototype.handleHoverBeat = function (pointer: any, offsetX: any) {
    if (_.isEmpty(pointer)) {
      return;
    }
    const selectedBeatMarkerObj = this.checkBeatAtPosition(pointer, offsetX);
    const isHoverBeat = !_.isEmpty(selectedBeatMarkerObj);
    if (isHoverBeat) {
      if (this.beatHover) {
        this.beatHover.rectangle.set({
          fill: this.normalColor[this.beatHover.originType],
          borderColor: this.normalColor[this.beatHover.originType],
        });
        this.beatHover.triangle.set({
          fill: this.normalColor[this.beatHover.originType],
          borderColor: this.normalColor[this.beatHover.originType],
        });
      }
      this.beatHover = selectedBeatMarkerObj.selectedBeatMarker;
      this.beatHover.rectangle.set({
        fill: HOVER_BEAT_COLOR[this.beatHover.originType],
        borderColor: HOVER_BEAT_COLOR[this.beatHover.originType],
      });
      this.beatHover.triangle.set({
        fill: HOVER_BEAT_COLOR[this.beatHover.originType],
        borderColor: HOVER_BEAT_COLOR[this.beatHover.originType],
      });
      this.canvas.bringToFront(this.beatHover.rectangle);
      this.canvas.bringToFront(this.beatHover.triangle);
      this.canvas.bringToFront(this.beatHover.text);
    } else if (this.beatHover) {
      this.beatHover.rectangle.set({
        fill: this.normalColor[this.beatHover.originType],
        borderColor: this.normalColor[this.beatHover.originType],
      });
      this.beatHover.triangle.set({
        fill: this.normalColor[this.beatHover.originType],
        borderColor: this.normalColor[this.beatHover.originType],
      });
    }
    this.render();
  };

  BeatMarkers.prototype.addBeat = function (
    clickedOffsetX: any,
    offsetX: any,
    beatTypeNumber: any,
  ) {
    // *: Check for adding duplicate beat which caused infinity bpm value
    /**
     * Determines whether a beat marker already exists near the clicked pixel offset. Finds a marker whose pixel offset is within plus or minus 8 pixels (the rectangle width) of the click.
     *
     * @returns The nearby existing beat marker, or undefined.
     */
    const isAdded = _.find(
      this.beatMarkers,
      (x) =>
        this.indexToPixOffset(clickedOffsetX, offsetX) >= this.indexToPixOffset(x, offsetX) - 8 &&
        this.indexToPixOffset(clickedOffsetX, offsetX) <= this.indexToPixOffset(x, offsetX) + 8,
    ); // *: 8 is width of rectangle
    if (!_.includes(this.beatMarkers, clickedOffsetX) && !isAdded) {
      /**
       * Finds the insertion index for a newly clicked beat marker among the sorted beatMarkers. Returns the index whose marker is below the click and whose next marker is above it, or the last position when clicking past the final marker.
       *
       * @returns The insertion index, or -1 if none matches.
       */
      const addIndex = _.findIndex(
        this.beatMarkers,
        (x, index) =>
          (clickedOffsetX > x && clickedOffsetX < this.beatMarkers[index + 1]) ||
          (clickedOffsetX > x && !this.beatMarkers[index + 1]),
      );
      if (addIndex > -1) {
        this.beatMarkers.splice(addIndex + 1, 0, clickedOffsetX);
        if (this.isAppliedAI) {
          this.originalHesBeatStatus.splice(addIndex + 1, 0, beatTypeNumber);
          this.currentHesBeatStatus.splice(addIndex + 1, 0, beatTypeNumber);
        }
      } else {
        this.beatMarkers.unshift(clickedOffsetX);
        if (this.isAppliedAI) {
          this.originalHesBeatStatus.unshift(beatTypeNumber);
          this.currentHesBeatStatus.unshift(beatTypeNumber);
        }
      }
      this.handleOpenSnackbar(`${convertBeatTypeNumberToText(beatTypeNumber)}-beat added`);
      this.reDrawBeatMarkers(offsetX, false);
      this.render();
    }
  };

  BeatMarkers.prototype.delete = function (pointer: any, offsetX: any) {
    // *: Find beat marker with point
    /**
     * Finds the visible beat marker whose rectangle or triangle bounding box contains the pointer position. Filters arrayBeatMarker requiring visibility and both x and y within either shape.
     *
     * @returns The matching visible beat marker, or undefined.
     */
    const beatMarker = _.find(
      this.arrayBeatMarker,
      (beat) =>
        beat.rectangle.visible &&
        beat.triangle.visible &&
        beat.text.visible &&
        ((pointer.x >= beat.rectangle.left &&
          pointer.x <= beat.rectangle.left + beat.rectangle.width &&
          pointer.y >= beat.rectangle.top &&
          pointer.y <= beat.rectangle.top + beat.rectangle.height) ||
          (pointer.x >= beat.triangle.left &&
            pointer.x <= beat.triangle.left + beat.triangle.width &&
            pointer.y >= beat.triangle.top &&
            pointer.y <= beat.triangle.top + beat.triangle.height)),
    ); // *: Click rectangle or triangle

    if (beatMarker) {
      const x = Math.round((beatMarker.rectangle.left + 4) / this.config.indexToPix + offsetX);

      // *: Find index of above beat marker
      /**
       * Finds the index of the last beatMarkers entry equal to the given sample position. Uses lodash findLastIndex for the match.
       *
       * @returns The last matching index, or -1.
       */
      const index = _.findLastIndex(this.beatMarkers, (ev) => ev === x);

      _.remove(this.beatMarkers, (ev, idx) => idx === index);
      if (this.isAppliedAI) {
        _.remove(this.originalHesBeatStatus, (ev, idx) => idx === index);
        _.remove(this.currentHesBeatStatus, (ev, idx) => idx === index);
      }
      _.remove(
        this.arrayBeatMarker,
        (x) =>
          x.rectangle === beatMarker.rectangle &&
          x.triangle === beatMarker.triangle &&
          x.text === beatMarker.text,
      );
      this.canvas.remove(beatMarker.rectangle, beatMarker.triangle, beatMarker.text);

      this.draw(offsetX, false);
      this.render();
    }
  };

  BeatMarkers.prototype.deleteBeatByObject = function (
    selectedBeatMarker: any,
    selectedBeatMarkerIndex: any,
    offsetX: any,
  ) {
    this.beatMarkers.splice(selectedBeatMarkerIndex, 1);
    this.currentHesBeatStatus.splice(selectedBeatMarkerIndex, 1);
    this.originalHesBeatStatus.splice(selectedBeatMarkerIndex, 1);
    this.handleOpenSnackbar('Beat deleted');
    this.reDrawBeatMarkers(offsetX, false);
    this.render();
  };

  BeatMarkers.prototype.changeBeatType = function (
    selectedBeatMarker: any,
    selectedBeatMarkerIndex: any,
    beatTypeNumber: any,
    offsetX: any,
  ) {
    this.originalHesBeatStatus[selectedBeatMarkerIndex] = beatTypeNumber;
    this.currentHesBeatStatus[selectedBeatMarkerIndex] = beatTypeNumber;
    this.handleOpenSnackbar(`Change to ${convertBeatTypeNumberToText(beatTypeNumber)}-beat`);
    this.reDrawBeatMarkers(offsetX, false);
    this.render();
  };

  BeatMarkers.prototype.setBeatMarkersVisibility = function (isVisibility: any) {
    this.isVisibility = isVisibility;

    _.forEach(this.arrayLabel, (label, index) => {
      if (index < this.sizeLabel) {
        label.visible = this.isVisibility;
      } else {
        label.visible = false;
      }
    });

    _.forEach(this.arrayBeatMarker, (marker, index) => {
      if (index < this.sizeBeatMarker) {
        marker.text.visible = this.isVisibility;
        marker.triangle.visible = this.isVisibility;
        marker.rectangle.visible = this.isVisibility;
      } else {
        marker.text.visible = false;
        marker.triangle.visible = false;
        marker.rectangle.visible = false;
      }
    });
  };

  BeatMarkers.prototype.indexToPixOffset = function (index: any, offsetX: any) {
    const { indexToPix } = this.config;
    return (index - offsetX) * indexToPix;
  };

  BeatMarkers.prototype.reDrawBeatMarkers = function (offsetX: any, isInViewAllMode: any) {
    _.forEach(this.arrayBeatMarker, (beatMarker) => {
      this.canvas.remove(beatMarker.rectangle, beatMarker.triangle, beatMarker.text);
    });
    this.arrayBeatMarker.length = 0;

    _.forEach(this.arrayLabel, (label) => {
      this.canvas.remove(label);
    });
    this.arrayLabel.length = 0;

    this.draw(offsetX, isInViewAllMode);
  };

  BeatMarkers.prototype.applyAI = function (
    isAppliedAI: any,
    offsetX: any,
    isInViewAllMode: any,
    beatMarkers: any = [],
    hesBeatStatus: any = [],
    isShowVES: any,
    isShowSVES: any,
    aiData: any,
  ) {
    this.isAppliedAI = true;

    this.beatMarkers = [...beatMarkers];
    this.originalHesBeatStatus = [...hesBeatStatus];
    this.currentHesBeatStatus = [...hesBeatStatus];
    this.aiData = aiData;
    this.isShowVES = isShowVES;
    this.isShowSVES = isShowSVES;
    if (!isShowVES) {
      this.changeHesBeatStatus(60);
    }
    if (!isShowSVES) {
      this.changeHesBeatStatus(70);
    }
    this.reDrawBeatMarkers(offsetX, isInViewAllMode);
  };

  BeatMarkers.prototype.calculateAIHeartRate = function () {
    const aiHeartRateArray = [];
    let sum = 0;
    if (
      this.aiData.beats.length &&
      this.aiData.hesBeatStatus.length &&
      this.aiData.hesEventStatus.length
    ) {
      for (let i = 0; i < this.aiData.beats.length - 1; i += 1) {
        const bpm = this.getBeatMarkerLabel(this.aiData.beats[i], this.aiData.beats[i + 1], false);
        sum += bpm;
        aiHeartRateArray.push(bpm);
      }
      const maxAIHeartRate = _.max(aiHeartRateArray);
      const minAIHeartRate = _.min(aiHeartRateArray);
      const averageAIHeartRate = Math.round(sum / this.aiData.beats.length);
      return { maxAIHeartRate, minAIHeartRate, averageAIHeartRate };
    }
    return { maxAIHeartRate: 0, minAIHeartRate: 0, averageAIHeartRate: 0 };
  };

  BeatMarkers.prototype.getBeatMarkers = function () {
    return [...this.beatMarkers];
  };

  BeatMarkers.prototype.getHesBeatStatus = function () {
    return [...this.currentHesBeatStatus];
  };

  BeatMarkers.prototype.changeHesBeatStatus = function (hes: any) {
    this.currentHesBeatStatus = _.map(this.currentHesBeatStatus, (status) => {
      if (status === hes) {
        return 1;
      }
      return status;
    });
  };

  BeatMarkers.prototype.toggleVES = function (offsetX: any, isInViewAllMode: any) {
    this.isShowVES = !this.isShowVES;
    if (this.isShowVES) {
      this.currentHesBeatStatus = [...this.originalHesBeatStatus];
      if (!this.isShowSVES) {
        this.changeHesBeatStatus(70);
      }
    } else {
      this.changeHesBeatStatus(60);
    }
    this.reDrawBeatMarkers(offsetX, isInViewAllMode);
    this.render();
  };

  BeatMarkers.prototype.toggleSVES = function (offsetX: any, isInViewAllMode: any) {
    this.isShowSVES = !this.isShowSVES;
    if (this.isShowSVES) {
      this.currentHesBeatStatus = [...this.originalHesBeatStatus];
      if (!this.isShowVES) {
        this.changeHesBeatStatus(60);
      }
    } else {
      this.changeHesBeatStatus(70);
    }
    this.reDrawBeatMarkers(offsetX, isInViewAllMode);
    this.render();
  };

  BeatMarkers.prototype.checkBeatAtPosition = function (pointer: any, offsetX: any) {
    // *: Find beat marker with point
    /**
     * Finds the visible beat marker whose rectangle or triangle contains the pointer's x coordinate. Filters arrayBeatMarker requiring rectangle, triangle and text visibility plus an x-range hit on either shape.
     *
     * @returns The matching visible beat marker, or undefined.
     */
    const selectedBeatMarker = _.find(
      this.arrayBeatMarker,
      (beat) =>
        beat.rectangle.visible &&
        beat.triangle.visible &&
        beat.text.visible &&
        ((pointer.x >= beat.rectangle.left &&
          pointer.x <= beat.rectangle.left + beat.rectangle.width) ||
          // && pointer.y >= beat.rectangle.top && pointer.y <= beat.rectangle.top + beat.rectangle.height
          (pointer.x >= beat.triangle.left &&
            pointer.x <= beat.triangle.left + beat.triangle.width)),
      // && pointer.y >= beat.triangle.top && pointer.y <= beat.triangle.top + beat.triangle.height
    ); // *: Click rectangle or triangle
    if (selectedBeatMarker) {
      const x = Math.round(
        (selectedBeatMarker.rectangle.left + 4) / this.config.indexToPix + offsetX,
      );
      // *: Find index of found beat marker
      /**
       * Finds the index of the last beatMarkers entry equal to the given sample position. Uses lodash findLastIndex for the match.
       *
       * @returns The last matching index, or -1.
       */
      const selectedBeatMarkerIndex = _.findLastIndex(this.beatMarkers, (ev) => ev === x);
      return {
        selectedBeatMarker,
        selectedBeatMarkerIndex,
        selectedBeatMarkerSample: this.beatMarkers[selectedBeatMarkerIndex],
        selectedBeatTypeNumber: formatHesBeatStatus(
          this.currentHesBeatStatus[selectedBeatMarkerIndex],
        ),
      };
    }
    return null;
  };

  BeatMarkers.prototype.getSelectedBulkBeatMarkers = function (
    startSample: any,
    endSample: any,
  ): any {
    /**
     * Selects the beat markers whose sample positions fall within the given startSample to endSample range. Filters beatMarkers inclusively between the two bounds.
     *
     * @returns Beat markers within the sample range.
     */
    const filteredBulkBeatMarkers = this.beatMarkers.filter(
      (beat: any) => beat >= startSample && beat <= endSample,
    );
    if (filteredBulkBeatMarkers.length > 0) {
      const selectedBulkBeatMarkers: any = [];
      filteredBulkBeatMarkers.forEach((selectedBeatMarker: any) => {
        /**
         * Finds the index in beatMarkers of the currently selected beat marker sample. Uses lodash findIndex matching selectedBeatMarker.
         *
         * @returns The index of the selected marker, or -1.
         */
        const selectedBeatMarkerIndex = _.findIndex(
          this.beatMarkers,
          (x) => x === selectedBeatMarker,
        );
        selectedBulkBeatMarkers.push({
          selectedBeatMarker,
          selectedBeatMarkerIndex,
          selectedBeatMarkerSample: this.beatMarkers[selectedBeatMarkerIndex],
        });
      });
      return selectedBulkBeatMarkers;
    }
    return [];
  };

  BeatMarkers.prototype.deleteMultipleBeat = function ({
    startSample,
    endSample,
    offsetX,
  }: any): any {
    const filteredDeleteBeatSample: any = [];
    const filteredDeleteBeatIndex: any = [];
    this.beatMarkers.forEach((beatSample: any, index: any) => {
      if (beatSample >= startSample && beatSample <= endSample) {
        filteredDeleteBeatSample.push(beatSample);
        filteredDeleteBeatIndex.push(index);
      }
    });
    this.beatMarkers = this.beatMarkers.filter(
      (ev: any, idx: any): any => !filteredDeleteBeatIndex.includes(idx),
    );
    this.currentHesBeatStatus = this.currentHesBeatStatus.filter(
      (ev: any, idx: any): any => !filteredDeleteBeatIndex.includes(idx),
    );
    this.originalHesBeatStatus = this.originalHesBeatStatus.filter(
      (ev: any, idx: any): any => !filteredDeleteBeatIndex.includes(idx),
    );
    this.arrayBeatMarker.forEach((beat: any): any => {
      if (filteredDeleteBeatSample.includes(beat.beatSample)) {
        this.canvas.remove(beat.rectangle, beat.triangle, beat.text);
      }
    });
    if (!_.isEmpty(filteredDeleteBeatIndex)) {
      this.handleOpenSnackbar(
        filteredDeleteBeatIndex.length > 1
          ? `${filteredDeleteBeatIndex.length} beats deleted`
          : 'Beat deleted',
      );
    }
    this.reDrawBeatMarkers(offsetX, false);
    this.render();
  };

  BeatMarkers.prototype.changeMultipleBeatType = function (
    startSample: any,
    endSample: any,
    offsetX: any,
    beatTypeNumber: any,
  ) {
    const selectedBulkBeatMarkers = this.getSelectedBulkBeatMarkers(startSample, endSample);
    if (selectedBulkBeatMarkers?.length > 0) {
      if (beatTypeNumber) {
        selectedBulkBeatMarkers.forEach((item: any) => {
          this.originalHesBeatStatus[item.selectedBeatMarkerIndex] = beatTypeNumber;
          this.currentHesBeatStatus[item.selectedBeatMarkerIndex] = beatTypeNumber;
        });
      } else {
        this.beatMarkers.splice(
          selectedBulkBeatMarkers[0].selectedBeatMarkerIndex,
          selectedBulkBeatMarkers.length,
        );
        this.originalHesBeatStatus.splice(
          selectedBulkBeatMarkers[0].selectedBeatMarkerIndex,
          selectedBulkBeatMarkers.length,
        );
        this.currentHesBeatStatus.splice(
          selectedBulkBeatMarkers[0].selectedBeatMarkerIndex,
          selectedBulkBeatMarkers.length,
        );
      }
      this.handleOpenSnackbar(
        selectedBulkBeatMarkers?.length > 1
          ? `${selectedBulkBeatMarkers.length} beats changed to ${convertBeatTypeNumberToText(beatTypeNumber)}-beat`
          : `Changed to ${convertBeatTypeNumberToText(beatTypeNumber)}-beat`,
      );
      this.reDrawBeatMarkers(offsetX, false);
      this.render();
    }
  };

  BeatMarkers.prototype.getJSONObject = function () {
    return {
      type: this.type,
      beatMarkers: this.beatMarkers,
    };
  };
})();

export { BeatMarkers };
export default { BeatMarkers };
